// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanVersion.yaml
// Generated: 2026-06-02T14:10:17.892Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePlanVersion, UpdatePlanVersion, PlanVersion } from '@/types/finance/PlanVersion';

/**
 * PlanVersion Service
 * CRUD operations for PlanVersion via the ABP API.
 */
export const planVersionService = new EntityService<PlanVersion, CreatePlanVersion, UpdatePlanVersion>(
  '/api/finance/planversion',
  'PlanVersion',
);
